<ng-container [formGroup]="form">
  <div class="form-group" [hidden]="form?.disabled">
    <h3>{{ labels.agents.agents }}</h3>
    <div formArrayName="agentsArr" [hidden]="form?.get('agentsArr')?.disabled">
      <div
        *ngFor="
          let agent of getRow.controls;
          let i = index;
          let last = last;
          let first = first
        "
      >
        <div class="form-row align-items-end" [formGroupName]="i">
          <ng-container *ngIf="form.get('agentsArr').at(i) as group">
            <ng-container *ngIf="i === 0">
              <div class="form-group col-lg-2">
                <app-dc-select
                  [label]="labels.agents.type"
                  closeOnSelect="true"
                  [id]="'type'"
                  [items]="agentTypeItems"
                  type="text"
                  formControlName="id"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <div class="form-group col-lg-4">
                <app-dc-select
                  closeOnSelect="true"
                  [label]="labels.agents.entityName"
                  [items]="(group.value?.id | filterEntities) | async"
                  type="text"
                  formControlName="entityName"
                ></app-dc-select>
              </div>
              <div class="form-group col-lg-2">
                <app-dc-input
                  [label]="labels.agents.lei"
                  [id]="'lei'"
                  type="text"
                  formControlName="lei"
                  [readonly]="true"
                ></app-dc-input>
              </div>
              <app-dc-plus-minus
                (minusClick)="deleteRow(i)"
                (plusClick)="addRow()"
                [showPlus]="first === last"
                *ngIf="!group.get('entityName').readOnly">
              </app-dc-plus-minus>
            </ng-container>

            <ng-container *ngIf="i > 0">
              <div class="form-group col-lg-2">
                <app-dc-select
                  closeOnSelect="true"
                  [id]="'type'"
                  [items]="agentTypeItems"
                  type="text"
                  formControlName="id"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <div class="form-group col-lg-4">
                <app-dc-select
                  closeOnSelect="true"
                  [items]="(group.value?.id | filterEntities) | async"
                  type="text"
                  formControlName="entityName"
                ></app-dc-select>
              </div>
              <div class="form-group col-lg-2">
                <app-dc-input
                  [id]="'lei'"
                  type="text"
                  formControlName="lei"
                  [readonly]="true"
                ></app-dc-input>
              </div>
              <app-dc-plus-minus
                (minusClick)="deleteRow(i)"
                (plusClick)="addRow()"
                [showPlus]="last"
                *ngIf="!group.get('entityName').readOnly">
              </app-dc-plus-minus>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
